import { defineComponent as w, ref as c, watch as b, computed as V, resolveComponent as m, createBlock as I, openBlock as n, withCtx as g, createVNode as C, createElementBlock as k, Fragment as _, renderList as $, normalizeClass as M, createElementVNode as u, createCommentVNode as S, toDisplayString as i } from "vue";
import { v as T } from "../../vsInput-CMeU-o-_.mjs";
import { v as x } from "../../vsAvatar-BwyAoiWv.mjs";
import { v as B } from "../../vsModal-BLdVBDEF.mjs";
import { v as D } from "../../vsSearchbar-BcFFAVue.mjs";
import { v as N } from "../../vsCard-CgHEnE92.mjs";
import { s as z } from "../../index-Dy_WMDOX.mjs";
import { _ as A } from "../../_plugin-vue_export-helper-CHgC5LLL.mjs";
const E = w({
  name: "vs-instance-picker",
  components: {
    vsInput: T,
    vsAvatar: x,
    vsModal: B,
    vsSearchbar: D,
    vsCard: N
  },
  props: {
    instances: {
      type: Array,
      default: () => []
    },
    currentInstanceID: {
      type: String,
      default: ""
    },
    modelValue: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "instance:selected"],
  setup(e, { emit: t }) {
    const r = c(e.modelValue);
    b(r, () => {
      t("update:modelValue", r);
    }), b(() => e.modelValue, () => {
      r.value = e.modelValue;
    });
    const l = c(""), p = ["name", "footer"], v = V(() => z(e.instances, p, l.value)), d = V(() => e.instances.find((o) => o.id === e.currentInstanceID)), a = c();
    return { showModal: r, searchText: l, filteredInstances: v, currentInstance: d, searchbar: a, openModal: () => {
      r.value = !0, setTimeout(() => {
        a.value.$el.children[1].focus();
      }, 100);
    }, focusSearchbar: () => {
      a.value.$el.children[1].focus();
    } };
  }
}), O = { class: "flex items-center h-full" }, U = { class: "font-bold w-full leading-tight" }, F = {
  key: 0,
  class: "text-xs w-full opacity-75 leading-tight"
};
function K(e, t, r, l, p, v) {
  const d = m("vs-searchbar"), a = m("vs-card"), h = m("vs-modal");
  return n(), I(h, {
    modelValue: e.showModal,
    "onUpdate:modelValue": t[1] || (t[1] = (s) => e.showModal = s),
    buttonless: "",
    onOpened: e.focusSearchbar,
    onClosed: t[2] || (t[2] = (s) => e.searchText = ""),
    class: "overflow-y-auto z-10 relative"
  }, {
    default: g(({ close: s }) => [
      C(d, {
        ref: "searchbar",
        class: "bg-white my-5",
        modelValue: e.searchText,
        "onUpdate:modelValue": t[0] || (t[0] = (o) => e.searchText = o)
      }, null, 8, ["modelValue"]),
      (n(!0), k(_, null, $(e.filteredInstances, (o, L) => (n(), I(a, {
        key: o.id,
        class: M([e.currentInstanceID === o.id ? "bg-primary text-on-primary" : "", "cursor-pointer border border-primary-500 border-opacity-0 hover:border-opacity-100 my-1"]),
        onClick: (y) => {
          e.$emit("instance:selected", o.id), s(), e.searchText = "";
        }
      }, {
        default: g(() => [
          u("div", O, [
            u("div", null, [
              u("div", U, i(e.instances.findIndex((y) => y.id === o.id) + 1) + ". " + i(o == null ? void 0 : o.name), 1),
              o.footer ? (n(), k("div", F, i(o.footer), 1)) : S("", !0)
            ])
          ])
        ]),
        _: 2
      }, 1032, ["class", "onClick"]))), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "onOpened"]);
}
const f = /* @__PURE__ */ A(E, [["render", K]]);
f.install = (e) => {
  e.component(f.name, f);
};
export {
  f as default
};
//# sourceMappingURL=index.mjs.map
